module.exports = __webpack_public_path__ + "static/media/tomorrow-edition-2025.2f9ed69d.jpg";